import React from 'react'
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { decrypt } from '../../../common/enc_dec';
import { useEffect } from 'react';
import { course } from '../../../slices/courseSlice';
import CourseDetailsView from '../trainingReport/courseDetailsView';
import UsersCertificates from './usersCertificates';

const ViewCertification = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { id, total_certificates } = location?.state || {};
    const queryParams = new URLSearchParams(location.search);
    const _id = queryParams.get("id") ? decrypt(queryParams.get("id")) : null;
    const courseId = id || _id;

    useEffect(() => {
        if (courseId) {
            dispatch(course({ id: courseId }));
        }
    }, [dispatch, courseId]);
    return (
        <div className="content-page">
            <CourseDetailsView />

            <div className="card mt-3 shadow-sm">
                <div className="card-body">
                    <h5 className="card-title fw-semibold">Certification Report</h5>
                    <p className="card-text text-muted">
                        <UsersCertificates />
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ViewCertification;